//@flow
import React from 'react';
import Link from '../../../components/Link';

const config = {
  title: 'Unlimited Office Snacks',
  subtitle: 'Truly unlimited snacks we deliver and set up for one price with no surprises.',
};

const {title, subtitle} = config;

const OfficePricing = (props:any) => {
  return (
    <div className="office-pricing">
      <div className="top">
        <h2>{title}</h2>
        <div className="subtitle">
          {subtitle}
        </div>
      </div>
      <div className="description">
        <h3>One Price. No Surprises.</h3>
      </div>
      <div className="row main-plans">
        {_mainPlan('Unlimited bulk snacks', 20)}
      </div>

      <h3>Optional Boosters</h3>
      <div className="text-4">per employee/month</div>
      <div className="row addon-plans">
        {_addOn('COFFEE - $6')}
        {_addOn('JERKY - $4')}
      </div>

      <div className="addon-plans-subtitle">
        Add both boosters for just $0.50 per employee/day
      </div>

      <div className="bottom">
        <Link to="/office#office-form">
          <button className="cta button">
            Learn More
          </button>
        </Link>
      </div>
    </div>
  );
};


function _mainPlan(name:string, price:number) {
  return (
    <div className="columns small-12">
      <div className={`main-plan ${name.toLowerCase()}`}>
        <div className="text-2-bold">{name}</div>
        <div className="price"><span className="dollars">$</span>{price}</div>
        <div className="text-4">per employee/month</div>
        <div className="text-4 office-pricing-subtext">($1 per employee/day)</div>
      </div>
    </div>
  );
}

function _addOn(name:string, className?:string) {
  return (
    <div className="columns small-12 medium-6">
      <div className={`addon-plan ${className || ''}`}>
        <div className="addon-name">{name}</div>
      </div>
    </div>
  );
}

export default OfficePricing;
